import { gql } from '@apollo/client';

export const GET_COUNTRY_VAT_CONFIGS = gql`
    query GetCountryVatConfigs {
        countryVatConfigs {
            id
            countryCode
            countryName
            vatPercent
            createdAt
            updatedAt
        }
    }
`;

export const GET_TAX_CODE_CONFIGS = gql`
    query GetTaxCodeConfigs {
        taxCodeConfigs {
            id
            code
            description
            isZeroRated
            createdAt
            updatedAt
        }
    }
`;
